import { ApprovalStatus } from 'models/ApiEnums';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const ApprovalStatusName: React.FC<{ approvalStatus: ApprovalStatus; bold?: boolean; }> = (props) => {
    const { t } = useTranslation();
    return props.bold === true
        ? <b>{t(`Common.ApprovalStatus.${ApprovalStatus[props.approvalStatus]}`)}</b>
        : <span>{t(`Common.ApprovalStatus.${ApprovalStatus[props.approvalStatus]}`)}</span>;
};

export default ApprovalStatusName;